// This file is auto-generated during build. Do not edit.

export interface AFHConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_JUE_API_BASE_URL: string;
  VITE_DESCRIPTION_API_URL: string;
}

export const config: AFHConfig = {
  VITE_CDN_URL: "https://d3h3nxtl6rlfz4.cloudfront.net",
  VITE_CDN_ID: "EWA0DBVP6VUNE",
  VITE_JAMS_BACKEND_URL: "https://wbirepr5cc.execute-api.us-west-2.amazonaws.com/prod",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.sodasoft.io",
  VITE_JUE_API_BASE_URL: "https://api.soda-exports.sodasoft.io",
  VITE_DESCRIPTION_API_URL: "https://00rx9begca.execute-api.us-west-2.amazonaws.com/prod",
};
